'use strict';

;( () => {

	document.addEventListener( 'facetwp-loaded', () => {

		// Filter the "feed_page_pagination" pager facet output.
		const pager = document.querySelector( '.facetwp-facet-feed_page_pagination' );
		if ( pager ) {

			// Prepend "0" to any single-digit page numbers.
			pager.querySelectorAll( '.facetwp-page[data-page]' ).forEach( ( page ) => {
				const num = parseInt( page.dataset.page, 10 );
				if ( ! isNaN( num ) && 10 > num ) {
					page.textContent = '0' + num;
				}
			});

			// If prev/next arrows are absent (first/last page), inject invisible
			// placeholders so the flex layout stays balanced.
			const pagerInner = pager.querySelector( '.facetwp-pager' );
			if ( pagerInner ) {
				if ( ! pagerInner.querySelector( '.facetwp-page.prev' ) ) {
					const placeholder = document.createElement( 'a' );
					placeholder.classList.add( 'facetwp-page', 'prev', 'facetwp-page--placeholder' );
					placeholder.setAttribute( 'aria-hidden', 'true' );
					pagerInner.prepend( placeholder );
				}
				if ( ! pagerInner.querySelector( '.facetwp-page.next' ) ) {
					const placeholder = document.createElement( 'a' );
					placeholder.classList.add( 'facetwp-page', 'next', 'facetwp-page--placeholder' );
					placeholder.setAttribute( 'aria-hidden', 'true' );
					pagerInner.append( placeholder );
				}
			}
		}

		// For each search block, show ".search-results" only when its input is non-empty,
		// and clear sibling search blocks when a new search is started.
		const searchBlocks = [ ...document.querySelectorAll( '[data-search]' ) ];

		// Extract the FacetWP facet name from a block by reading the facetwp-facet-{name} class.
		const getFacetName = ( block ) => {
			const facetEl = block.querySelector( '[class*="facetwp-facet-"]' );
			if ( ! facetEl ) {
				return null;
			}
			const match = [ ...facetEl.classList ].find( ( c ) => /^facetwp-facet-.+/.test( c ) && 'facetwp-facet' !== c );
			return match ? match.replace( 'facetwp-facet-', '' ) : null;
		};

		searchBlocks.forEach( ( block ) => {
			const input   = block.querySelector( 'input[type="text"]' );
			const results = block.querySelector( '.search-results' );

			if ( ! input || ! results ) {
				return;
			}

			// Update visibility for this block on every facetwp-loaded event.
			results.classList.toggle( 'visible', '' !== input.value.trim() );

			// When the user types in this block, clear all other blocks' inputs,
			// FWP facet state, and result visibility so their queries don't combine.
			if ( ! input.dataset.searchListenerAttached ) {
				input.dataset.searchListenerAttached = 'true';
				input.addEventListener( 'input', () => {
					searchBlocks.forEach( ( otherBlock ) => {
						if ( otherBlock === block ) {
							return;
						}
						const otherInput = otherBlock.querySelector( 'input[type="text"]' );
						if ( otherInput ) {
							otherInput.value = '';
						}
						const facetName = getFacetName( otherBlock );
						if ( facetName ) {
							FWP.facets[ facetName ] = '';
						}
						const otherResults = otherBlock.querySelector( '.search-results' );
						if ( otherResults ) {
							otherResults.classList.remove( 'visible' );
						}
					});
				});
			}
		});

	});

	// Prevent FacetWP search facets from refreshing until at least `trigger` characters
	// have been typed. We wrap delay_refresh (the debounced function that calls FWP.autoload)
	// via the facetwp/ready hook, which fires after FWP.logic.search is fully defined.
	// DOMContentLoaded ensures FWP and FWP.hooks exist before we call addAction.
	document.addEventListener( 'DOMContentLoaded', () => {
		if ( 'object' !== typeof FWP || 'object' !== typeof FWP.hooks ) {
			return;
		}
		FWP.hooks.addAction( 'facetwp/ready', () => {
			const trigger = 2;
			const originalDelayRefresh = FWP.logic.search.delay_refresh;
			FWP.logic.search.delay_refresh = ( facetName ) => {
				const input = document.querySelector( '.facetwp-facet[data-name="' + facetName + '"] .facetwp-search' );
				const val   = input ? input.value : '';
				if ( 0 < val.length && trigger > val.length ) {
					return;
				}
				originalDelayRefresh( facetName );
			};
		});
	});
})();
